"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureCalledOnlyOnce = void 0;
var assert_sidecar_1 = require("./assert-sidecar");
var imports_1 = require("./imports");
var _onces = [];
var ensureCalledOnlyOnce = function (key) {
    assert_sidecar_1.assert.notEmptyString(key);
    key = key.trim();
    if (imports_1.l.includes(_onces, key)) {
        assert_sidecar_1.assert.failed('ensureCalledOnlyOnce failed', key);
    }
    _onces.push(key);
};
exports.ensureCalledOnlyOnce = ensureCalledOnlyOnce;
